import styled from 'styled-components/macro'

export default styled.article`
  background: #ffffff;
  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.16);
  border-radius: 4px;
  padding: 24px 24px 32px;
`
